/* Generated USDT deposit hooks unit. */
import { getAuthSessionRevision } from '@/lib/authStorage';
import { useCallback, useEffect, useRef } from 'react';
// Fence before effects, including A -> B -> A ownership changes.
export const useWalletRequestScope = (scope) => {
  const sessionRevision = getAuthSessionRevision();
  const current = useRef({ scope, revision: 0 });
  const mounted = useRef(true);
  if (current.current.scope !== scope) current.current = { scope, revision: current.current.revision + 1 };
  const revision = current.current.revision;
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  return useCallback(() => mounted.current && current.current.revision === revision && getAuthSessionRevision() === sessionRevision, [revision, sessionRevision]);
};
